import { render, staticRenderFns } from "./icon-buy-again.vue?vue&type=template&id=05c121f9"
import script from "./icon-buy-again.vue?vue&type=script&lang=js"
export * from "./icon-buy-again.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports